import auth from "../middlewares/auth";
export const customers = [
    {
        path: '/customers',
        component: () => import(/* webpackChunkName: "customer" */ '../views/customers/Index'),
        name: 'customers',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/customers/:id',
        component: () => import(/* webpackChunkName: "customer" */ '../views/customers/Details'),
        name: 'customers_view',
        meta: {
            middleware: [
                auth
            ]
        }
    },
    {
        path: '/customers/edit/:id',
        component: () => import(/* webpackChunkName: "customer" */ '../views/customers/Form'),
        name: 'customers_edit',
        meta: {
            middleware: [
                auth
            ]
        }
    },
];
